import {Card, Col, Image} from "antd";
import dummy from "../../../../assets/image/dummy_obj.png";

const PlatformDownloadCard = (props) => {
    const {data} = props;

    const language = localStorage.getItem("language");

    const platformDisplayName =
        data?.displayNameLanguage?.find((v) => v?.language === language)?.label ??
        data?.displayNameLanguage?.find((v) => v?.language === "en")?.label ??
        data?.displayName;

    return (
        <a href={data?.link} target={"_blank"}>
            <Card className={"platformDownloadCard h-full"}>
                <Col span={24} className={"text-center p-0"}>
                    <Image
                        width={115}
                        height={115}
                        src={data?.icon ? data?.icon : data?.defaultIcon ? data?.defaultIcon : dummy}
                        style={{objectFit: "cover"}}
                        preview={false}
                    />
                    <p className={"mt-6"}>{platformDisplayName}</p>
                </Col>
            </Card>
        </a>
    );
};

export default PlatformDownloadCard;
